<tt-page *ngIf="!!menu">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_info">
            <tt-input ttLabel="p2_exportproc_keyno" [ttModel]="menu.p2_exportproc_keyno" ttReadonly></tt-input>
            <tt-input ttLabel="p2_exportproc_name" [ttModel]="menu.p2_exportproc_name" ttReadonly></tt-input>
            <tt-input ttLabel="proc_name" [ttModel]="menu.proc_name" ttReadonly></tt-input>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_functions">
            <tt-button-goto [ttText]="'p2exportprocmenu_edit'" [ttGoto]="'p2exportproc'" [ttGotoParms]="{ p2_exportproc_keyno: menu.p2_exportproc_keyno }"></tt-button-goto>
            <tt-button-goto [ttText]="'p2exportprocmenu_p2exportprocusergroups'" [ttGoto]="'p2exportprocusergroups'" [ttGotoParms]="{ p2_exportproc_keyno: menu.p2_exportproc_keyno }"></tt-button-goto>
        </tt-card>
    </div>
</tt-page>
